module.exports = __webpack_public_path__ + "img/cover.a16c5b16.jpg";